module.exports = __webpack_public_path__ + "static/media/Cash-Money-icon.28e8969c.svg";